import React from 'react';
import breakpoints from '@99designs/asimov/platform-settings/settings/breakpoints';
import Responsive from 'react-responsive';

export default function Mobile({ children, values }) {
    return <Responsive maxWidth={breakpoints.normal[0]} children={children} values={values} />;
}



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/Mobile.jsx